import {
  VERTICAL_TYPES,
  type VerticalType,
  type VerticalConfig,
} from '@constants/verticalConstants';
import { verticalConfigs } from './verticals';

export type AppVertical = 'learn' | 'meta';

function resolveVertical(): VerticalType {
  const value = (process.env.APP_VERTICAL ?? 'learn').toLowerCase();
  return value === 'meta' ? VERTICAL_TYPES.META : VERTICAL_TYPES.LEARN;
}

export const activeVertical = resolveVertical();

export const appVertical: AppVertical =
  activeVertical === VERTICAL_TYPES.META ? 'meta' : 'learn';

export const verticalConfig: VerticalConfig = verticalConfigs[activeVertical];
